import { API, graphqlOperation } from 'aws-amplify';

import * as mutations from '../../../graphql/mutations';
import * as queries from '../../../graphql/queries';

export const getUserData = async userEmail => {
  try {
    const response = await API.graphql({
      query: queries.getUser,
      variables: { id: userEmail },
    });
    return response?.data?.getUser;
  } catch (e) {
    console.log(e);
  }
  return undefined;
};

export const getClient = async id => {
  try {
    const path = `clients/${id}`;
    const response = await API.get('centerlineportal', path);
    return response;
  } catch (e) {
    return e;
  }
};

export const updateUser = async input => {
  try {
    return await API.graphql(graphqlOperation(mutations.updateUser, { input }));
  } catch (e) {
    console.log(`Update User Error: ${JSON.stringify(e)}`);
    return false;
  }
};

export const createUserCustomer = async input => {
  try {
    await API.graphql(graphqlOperation(mutations.createUserCustomer, { input }));
    return true;
  } catch (e) {
    console.log(`Update Customers Error: ${JSON.stringify(e)}`);
    return false;
  }
};

export const deleteUserCustomer = async input => {
  try {
    await API.graphql(graphqlOperation(mutations.deleteUserCustomer, { input }));
    return true;
  } catch (e) {
    console.log(`Update Customers Error: ${JSON.stringify(e)}`);
    return false;
  }
};

export const updateUserCustomer = async input => {
  try {
    await API.graphql(graphqlOperation(mutations.updateUserCustomer, { input }));
    return true;
  } catch (e) {
    console.log(`Update UserCustomer Error: ${JSON.stringify(e)}`);
    return false;
  }
};

export const getAllCustomersForUser = async userId => {
  const allItems = [];
  let token = null;
  let complete = true;
  do {
    try {
      const response = await API.graphql({
        query: queries.listUserCustomers,
        variables: {
          filter: { userCustomersId: { eq: userId } },
          limit: 1000,
          nextToken: token,
        },
      });
      const page = response?.data?.listUserCustomers;
      if (page?.items) allItems.push(...page.items);
      token = page?.nextToken ?? null;
    } catch (e) {
      console.log('getAllCustomersForUser error:', e);
      token = null;
      complete = false;
    }
  } while (token);
  return { items: allItems, complete };
};
